import PublicEnv from 'shared/utils/public-env';

const isBackofficeHosted = typeof window !== 'undefined' && /^\/ecomm(?:\/|$)/.test(window.location.pathname);

export function getBackofficeHostedRequestHeaders(): Record<string, string> {
  if (!isBackofficeHosted) return {};

  const match = /^\/ecomm\/dispensaries\/([^/]+)(?:\/|$)/.exec(window.location.pathname);
  if (!match) return {};

  try {
    return { 'x-dutchie-dispensary-id': decodeURIComponent(match[1]) };
  } catch {
    return {};
  }
}

const AdminPublicEnv = {
  ...PublicEnv,
  adminBasePath: isBackofficeHosted ? '/ecomm' : undefined,
  graphqlUri: isBackofficeHosted ? '/api/ecom_admin/graphql' : PublicEnv.graphqlUri,
  isBackofficeHosted,
  useGetForHashedQueries: !isBackofficeHosted,
};

export default AdminPublicEnv;
